type MovbileMenuIconProps = {
	toggleDropdown?: () => void;
	height?: number;
	width?: number;
	className?: string;
};
const MovbileMenuIcon = ({ toggleDropdown, height, width, className }: MovbileMenuIconProps) => {
	return (
		<svg
			className={`${className} `}
			width={height || 24}
			height={width || 24}
			viewBox='0 0 24 24'
			scale={1}
			onClick={toggleDropdown}
		>
			<path
				d='M12 6v.01M12 12v.01M12 18v.01M12 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			></path>
		</svg>
	);
};

export default MovbileMenuIcon;
